import React from 'react';

import { useCopyContext } from '../../context/CopyContext';
import WrappedSupportersList from './SupportersList';

export function SupportersList() {
  const { supportersList } = useCopyContext();

  return (
    <WrappedSupportersList
      noSupportersMessage={supportersList.noSupportersMessage}
      displayDonateButton
    />
  );
}
